<template>
    <v-dialog v-model="infoBuildingDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark :color="toolbarColor">
                <v-btn icon dark @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>More Information</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="closeDialog()">Close</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-title>
                {{ currentBuilding.name }}
            </v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <v-card-subtitle class="pa-0">
                                <b>Created By:</b> {{ getCreatedBy() }}<br>
                                <b>Created Date:</b> {{ getCreatedDate() }}<br>
                                <b>Last Updated By:</b> {{ getLastUpdatedBy() }}<br>
                                <b>Last Updated Date:</b> {{ getLastUpdatedDate() }}
                            </v-card-subtitle>
                        </v-col>
                        <v-col cols="12" class="pb-0">
                            <v-card-subtitle class="font-weight-bold pa-0 pb-1">Basic Information</v-card-subtitle>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="currentBuilding.maxOccupancy" readonly hide-details
                                label="Max Occupancy" placeholder="Not available">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="currentBuilding.maxRoommateRequest" readonly hide-details
                                :items="maxRoommateRequestItems" label="Max Roommate Request"
                                placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="currentBuilding.minYearOfStudy" readonly hide-details
                                :items="minYearOfStudyItems" label="Min Year Of Study" placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="currentBuilding.mealPlanRequired" readonly :items="mealPlanRequiredItems"
                                label="Meal Plan Required" placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12" class="pb-0">
                            <v-card-subtitle class="font-weight-bold pa-0 pb-1">Gender Restriction</v-card-subtitle>
                            <v-checkbox v-model="currentBuilding.genderRestriction" dense readonly hide-details
                                label="Male" value="male">
                            </v-checkbox>
                            <v-checkbox v-model="currentBuilding.genderRestriction" dense readonly hide-details
                                label="Female" value="female">
                            </v-checkbox>
                            <v-checkbox v-model="currentBuilding.genderRestriction" dense readonly
                                label="Non-Binary" value="NonBinary">
                            </v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <v-card-subtitle class="font-weight-bold pb-1 px-0">Additional Information</v-card-subtitle>
                            <v-card-subtitle class="px-0 py-1">
                                <b>File:</b> {{ getContractConditionsFilename() }}<br>
                                <b>Uploaded By:</b> {{ getContractConditionsUploadedBy() }}<br>
                                <b>Date:</b> {{ getContractConditionsFileDate() }}
                            </v-card-subtitle>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="currentBuilding.internationalOnly" readonly hide-details
                                :items="internationalOnlyItems" label="International Only" placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="currentBuilding.enabled" readonly :items="enabledItems" label="Enabled"
                                placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="currentBuilding.notes" auto-grow counter="512" readonly label="Notes"
                                outlined placeholder="None">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'buildings-info',
    props: {
        currentBuilding: {
            required: true,
            type: Object
        },
        infoBuildingDialog: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            enabledRules: [
                v => !(v === "") || 'Enabled is required',
            ],
            mealPlanRequiredItems: [{
                    text: 'Yes',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                }
            ],
            internationalOnlyItems: [{
                    text: 'Yes',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                }
            ],
            maxRoommateRequestItems: [{
                    text: '1',
                    value: 1
                },
                {
                    text: '2',
                    value: 2
                },
                {
                    text: '3',
                    value: 3
                },
                {
                    text: '4',
                    value: 4
                },
                {
                    text: '5',
                    value: 5
                }
            ],
            minYearOfStudyItems: [{
                    text: '1',
                    value: 1
                },
                {
                    text: '2',
                    value: 2
                },
                {
                    text: '3',
                    value: 3
                },
                {
                    text: '4',
                    value: 4
                }
            ],
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeInfoBuildingDialog');
        },
        getContractConditionsFileDate() {
            if (this.currentBuilding && this.currentBuilding.fileContractConditions && this.currentBuilding.fileContractConditions.uploadedTimestamp) {
                let date = new Date(this.currentBuilding.fileContractConditions.uploadedTimestamp * 1000);
                return date.toDateString();
            }

            return `None`;
        },
        getContractConditionsFilename() {
            if (this.currentBuilding && this.currentBuilding.fileContractConditions && this.currentBuilding.fileContractConditions.file) {
                return this.currentBuilding.fileContractConditions.file;
            }

            return `None`;
        },
        getContractConditionsUploadedBy() {
            if (this.currentBuilding && this.currentBuilding.fileContractConditions && this.currentBuilding.fileContractConditions.uploadedByUsername) {
                return this.currentBuilding.fileContractConditions.uploadedByUsername;
            }

            return `None`;
        },
        getCreatedBy() {
            if (this.currentBuilding.createdByUsername) {
                return `${this.currentBuilding.createdByUsername}`;
            }

            return 'N/A';
        },
        getCreatedDate() {
            if (this.currentBuilding.createdTimestamp) {
                let date = new Date(this.currentBuilding.createdTimestamp * 1000);
                return date.toLocaleString();
            }

            return 'N/A';
        },
        getLastUpdatedBy() {
            if (this.currentBuilding.lastUpdatedByUsername) {
                return `${this.currentBuilding.lastUpdatedByUsername}`;
            }

            return 'N/A';
        },
        getLastUpdatedDate() {
            if (this.currentBuilding.lastUpdatedTimestamp) {
                let date = new Date(this.currentBuilding.lastUpdatedTimestamp * 1000);
                return date.toLocaleString();
            }

            return 'N/A';
        }
    },
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>

<style scoped>
.v-input--checkbox {
    margin-top: 0;
}
</style>